import {
  calculateBaseQuantity,
  getBaseUnitValue,
  getUnitFactorToBase,
  isWeightOrVolumeUnit,
} from "./pricing";

export const isBaseQuantityUnit = (unit, units = []) => isWeightOrVolumeUnit(unit, units);

export const calculatePurchaseBaseQuantity = (detail = {}, units = []) => {
  return calculateBaseQuantity(detail, units);
};

// Harga material berbasis berat/volume selalu disimpan per 1.000 base unit
// (Rp/kg untuk gram dan Rp/liter untuk ml).
export const calculatePurchaseDetailSubtotal = (detail = {}, units = []) => {
  const unitCost = Math.max(0, Number(detail?.unit_cost || 0));
  const baseQuantity = calculatePurchaseBaseQuantity(detail, units);

  return isBaseQuantityUnit(detail?.unit, units)
    ? Math.round(unitCost * (baseQuantity / 1000))
    : Math.round(unitCost * baseQuantity);
};

export const convertPurchaseWeightForUnit = (detail = {}, nextUnit, units = []) => {
  const previousUnit = detail?.unit || nextUnit;
  const previousBase = getBaseUnitValue(units, previousUnit);
  const nextBase = getBaseUnitValue(units, nextUnit);

  if (!["gram", "ml"].includes(nextBase)) return 0;

  const nextFactor = getUnitFactorToBase(units, nextUnit);
  if (previousBase !== nextBase) return 1;

  const previousFactor = getUnitFactorToBase(units, previousUnit);
  const previousWeight = Math.max(0, Number(detail?.weight || 0)) || 1;
  const converted = (previousWeight * previousFactor) / nextFactor;

  return Number(converted.toFixed(6));
};
